import api from "../../Hooks/axiosApi";

export const updateAssetsAndLiabilitiesService = (formData: any) => {
    const response = api.post(`/api/MppClient/UpdateAssetsAndLiabilitiesByClientId`, formData);
    return response;
};

export const getAssetsAndLiabilitiesByClientId = (clientId: string) => {
    const response = api.get(`/api/MppClient/GetAssetsAndLiabilitiesByClientId/${clientId}`);
    return response;
};